"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var financeSummaryBlockStyles_1 = require("./financeSummaryBlockStyles");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var FinanceQuotePrices_1 = require("../../../prices/finance/FinanceQuotePrices");
var LabelAfter_1 = require("../StaticContent/LabelAfter");
var react_intl_1 = require("react-intl");
var FinanceSummaryBlock = function (_a) {
    var finance = _a.finance, isMultiCurrency = _a.isMultiCurrency, taxLabel = _a.taxLabel;
    var _b, _c;
    var intl = react_intl_1.useIntl();
    var style = financeSummaryBlockStyles_1.default();
    var _d = finance.simulation, _e = _d.paymentValue, primaryPrice = _e[0], secondaryPrice = _e[1], frequency = _d.frequency, duration = _d.loanTermPeriod.value;
    return (<>
      <core_1.Typography className={style.repaymentLabel}>
        <Translation_1.default id="trans__checkout__confirmation_page__summary__finance_payment_label"/>
      </core_1.Typography>
      <FinanceQuotePrices_1.default primaryPrice={{
        value: primaryPrice.amount,
        currency: primaryPrice.currency,
    }} secondaryPrice={{
        value: (_b = secondaryPrice) === null || _b === void 0 ? void 0 : _b.amount,
        currency: (_c = secondaryPrice) === null || _c === void 0 ? void 0 : _c.currency,
    }} isMultiCurrency={isMultiCurrency} className={style.financeQuotePrice} dataTest="finance_summary:container:primary_quote" labelAfter={<LabelAfter_1.default className={style.labelAfter} duration={duration} frequency={intl.formatMessage({ id: frequency })}/>} taxLabel={taxLabel}/>
      <core_1.Typography variant="caption" component="div" className={style.repaymentLabel}>
        <Translation_1.default id="trans__checkout__confirmation_page__summary__finance_payment_reference_quote"/>
      </core_1.Typography>
    </>);
};
exports.default = FinanceSummaryBlock;
